import { getRemoteConfig, fetchAndActivate, getValue } from 'firebase/remote-config';
import { firebaseApp } from './firebase';

// Initialize Remote Config instance
const remoteConfig = getRemoteConfig(firebaseApp);

// Reasonable defaults for React SPA
remoteConfig.settings = {
  minimumFetchIntervalMillis: process.env.NODE_ENV === 'development' ? 0 : 60_000, // 1 min in prod, no cache in dev
  fetchTimeoutMillis: 10_000,
};

// Default values as fallbacks if remote values are missing
remoteConfig.defaultConfig = {
  ads_publisher_id: 'ca-pub-6690779336808264',
  ad_slot_ad1: '8057403001',
  ad_slot_ad2: '4429133276',
  ad_slot_ad3: '7590467322',
  ad_slot_ad4: '6337127225',
  ad_slot_ad5: '6337127225',
  ad_slot_ad6: '7590467322',
  ad_slot_ad7: '4429133276',
  ad_slot_ad8: '8057403001',
  ad_slot_ad9: '7590467322',
};

export async function initRemoteConfig() {
  try {
    await fetchAndActivate(remoteConfig);
  } catch (_) {
    // Swallow errors; defaults will be used
  }
}

export function getRemoteString(key, fallback = '') {
  try {
    const val = getValue(remoteConfig, key)?.asString?.();
    return val || fallback;
  } catch (_) {
    return fallback;
  }
}

export function getAdSlotFromRC(adNumber, fallback = '') {
  return getRemoteString(`ad_slot_ad${adNumber}`, fallback);
}

export function getPublisherIdFromRC(fallback = '') {
  return getRemoteString('ads_publisher_id', fallback);
}


